import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as icons from '@ant-design/icons-vue';
var AntIconsRegister = {
  install: function install(app) {
    Object.entries(icons).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        displayName = _ref2[0],
        icon = _ref2[1];
      app.component(displayName, icon);
    });
  }
};
export default AntIconsRegister;